const craneSessionTimer = import.meta.env.VITE_APP_CRANE_SESSION_TIMER;

export const sessionTimer = {
    namespaced: true,
    state: {
        startTime: null,
    },
    mutations: {
        setStartTime(state, timestamp) {
            state.startTime = timestamp;
        },
    },
    actions: {
        initSession({ commit }) {
            try {
                let stored = localStorage.getItem(craneSessionTimer);
                let now = Date.now();
                if (stored) {
                    const savedTime = parseInt(stored, 10);
                    commit("setStartTime", savedTime);
                } else {
                    localStorage.setItem(craneSessionTimer, now);
                    commit("setStartTime", now);
                }
            } catch (error) {
                console.error("Error in init Timer:", error);
            }
        },
        stopSession() {
            localStorage.removeItem(craneSessionTimer);
        },
    },
};
